import { useState, useCallback } from 'react'
import ChangePasswordModal from '@src/Pages/SettingsPage/LoginAndSecurity/ChangePasswordModal'
import { Card, CardContent, CardDescription, CardHeader, CardTitle, Button } from '@wove/web-ui'
import { Briefcase } from 'lucide-react'

const LoginAndSecurity = () => {
  const [changeVisible, setChangeVisible] = useState(false)
  const onChangeClose = useCallback(() => {
    setChangeVisible(false)
  }, [])
  const onChangeOpen = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    setChangeVisible(true)
  }, [])
  return (
    <section id="security" className="scroll-mt-20">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <div>
            <CardTitle className="text-2xl">Security</CardTitle>
            <CardDescription>Manage your login and security settings</CardDescription>
          </div>
          <Briefcase className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent className="space-y-6">
          <Button onClick={onChangeOpen}>Change password</Button>
        </CardContent>
      </Card>
      <ChangePasswordModal onClose={onChangeClose} isOpen={changeVisible} />
    </section>
  )
}

export default LoginAndSecurity
